

export const no_key_questions = [
    "question.paragraph",
    "question.infoBox",
    "question.heading",
    "question.richtext",
    "question.group",
];

export const staticQuestions = [
    "question.heading",
    "question.infoBox",
    "question.richtext",
    "question.paragraph",
];
